import React from 'react'
import { SystemStatusSection } from '../organisms/SystemStatusSection'
import RealTimeFeedback from '../organisms/RealTimeFeedback'

interface DashboardTemplateProps {
  activeFeedbackCount?: number
  totalApplicationsCount?: number
  pendingFeedbackCount?: number
  showThemeDebug?: boolean
}

export const DashboardTemplate: React.FC<DashboardTemplateProps> = ({
  activeFeedbackCount = 0,
  totalApplicationsCount = 0,
  pendingFeedbackCount = 0,
  showThemeDebug = true,
}) => {
  return (
    <>
      <SystemStatusSection 
        activeFeedbackCount={activeFeedbackCount}
        totalApplicationsCount={totalApplicationsCount}
        pendingFeedbackCount={pendingFeedbackCount}
      />
      {showThemeDebug && <RealTimeFeedback className="mb-6" />}
    </>
  )
} 